import axios from 'axios';
import api from '../../../utils/api';

export default {
  async fetchMenus({ _ }) {
    const { data } = await axios(api.menu.fetchMenus());
    return data.results;
  },
};
